import React, { useCallback } from 'react';

import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

type Props = {
  action: Function;
  label?: string;
  className?: string;
};

export default function AddMoreButton({ action, label = 'Add more' }: Props) {
  const handleClick = useCallback(() => action(), [action]);
  return (
    <div className="onboarding-add-more-button">
      <WpButton variant="tertiary" onClick={handleClick}>
        <WpIcon name="plus-circle" /> {label}
      </WpButton>
    </div>
  );
}
